export default __webpack_public_path__ + "static/media/C-004.9f63b6b6.png";